import { Request } from 'api';
import { AxiosResponse } from 'axios';

interface SelectedEvent {
    event: string;
    mark: string;
    date?: string;
    meet_date?: string | null;
    meet_name?: string;
    location?: string;
    result_value: number;
    result_unit: string;
}

interface ConfirmAthleticNetImportRequest {
    job_id: string;
    individual_uuid: string;
    selected_events: SelectedEvent[];
}

interface ConfirmAthleticNetImportResponse {
    success: boolean;
    imported_count: number;
    updated_count: number;
    skipped_count: number;
    message: string;
}

type ReturnType = Promise<AxiosResponse<ConfirmAthleticNetImportResponse>>;

const confirmAthleticNetImport = (data: ConfirmAthleticNetImportRequest): ReturnType => {
    return Request.post('/workouts/track-events/athletic-net-confirm-import', data);
};

export default confirmAthleticNetImport;
